import React from 'react';
import { connect } from 'react-redux';
import { WebAppState } from 'web/state/store.web';

import { AnimalKind, Equipment } from 'shared/api/api';
import ElistarFeedCurvePicker from './elistar-feed-curve-picker';
import EsfFeedCurvePicker from './esf-feed-curve-picker';

export interface FeedCurvePickerProps {
	usedInsideForm?: boolean;
	usedInsideTable?: boolean;
	penId?: string;
	feedCurveNumber?: number;
	onChange?: (feedCurveNumber: number | undefined) => void;
	disabled?: boolean;
	showAsLabel?: boolean;
	menuClassname?: string;
	dropdownIdentifier?: string;
	containerClassName?: string;
	className?: string;
	style?: any;
	theme?: 'light' | 'dark';
	animalKind?: AnimalKind;
}

const mapStateToProps = (state: WebAppState, props: FeedCurvePickerProps) => {
	const processEquipment = state.processEquipments.entities.find(pe => pe.equipment !== Equipment.Distriwin);

	return { processEquipment };
};

interface State {}

type Props = ReturnType<typeof mapStateToProps> & FeedCurvePickerProps;
export class SkioldFeedCurvePicker extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {};
	}

	public render() {
		if (this.props.processEquipment?.equipment === Equipment.ESF) {
			return <EsfFeedCurvePicker {...this.props} />;
		}
		if (this.props.processEquipment?.equipment === Equipment.Elistar) {
			return <ElistarFeedCurvePicker {...this.props} />;
		}
		return null;
	}
}

export default connect(mapStateToProps, {})(SkioldFeedCurvePicker);
